// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","409":"9e90ae8b","455":"b0748933","578":"85f65c0d","977":"23814c44"}[chunkId] + ".chunk.js";
};